'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
var $ = require("jquery");
var Login = /** @class */ (function () {
    function Login() {
        var id = '#bulletInputLoginPassword';
        if ($(id).length > 0) {
            $(id).focus();
        }
    }
    return Login;
}());
exports.Login = Login;
exports.default = Login;
